import { cvrBaseApiSlice } from "../apiSlice";

// CVR API endpoints to fetch data on a given CVR number.
export const cvrApiSlice = cvrBaseApiSlice.injectEndpoints({
    endpoints: builder => ({
        getCompany: builder.query({
            query: (args) => {
                return { url: `hentVirksomhed?cvrnummer=${args.companyNumber}&locale=da` }
            },
        }),
    })
});

export const {
    useGetCompanyQuery,
} = cvrApiSlice